import React, { useEffect, useRef, useState } from 'react';
import { CloseButton } from '@pushpay/button';
import { SearchIcon } from '@pushpay/iconography';
import { createUseStyles } from '@pushpay/styles';
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'flex',
    height: '56px',
    padding: '12px',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.colors['color-border-input']}`,
    maxWidth: '700px'
  },
  input: {
    width: '100%',
    font: theme.TYPOGRAPHY.BODY_1,
    border: 'none'
  },
  icon: {
    color: theme.colors['color-text-hint']
  }
}));
const EMPTY_STRING = '';
export const SearchBar = ({
  onChange,
  placeholder,
  clearButtonAriaLabel,
  classes: classesProp,
  'data-pp-at-target': targetId
}) => {
  const classes = useStyles(classesProp);
  const [value, setValue] = useState(EMPTY_STRING);
  const inputRef = useRef(null);

  const clearText = () => {
    setValue(EMPTY_STRING);
  };

  const onKeyDownHandler = event => {
    if (event.key === 'Escape') {
      clearText();
    }
  };

  useEffect(() => {
    if (onChange) {
      onChange(value);
    }
  }, [onChange, value]);
  useEffect(function focusSearchInput() {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    className: classes.input,
    value: value,
    onChange: event => setValue(event.target.value),
    placeholder: placeholder,
    onKeyDown: onKeyDownHandler
  }), value ? /*#__PURE__*/React.createElement(CloseButton, {
    className: classes.icon,
    "aria-label": clearButtonAriaLabel,
    onClick: clearText
  }) : /*#__PURE__*/React.createElement(SearchIcon, {
    className: classes.icon,
    "data-pp-at-target": `${targetId}-search-icon`
  }));
};